import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import { drawer } from "../../style/style";
import { zewalogo_customer, logoStyle2 } from "../../style/style";

import { getKeyByValue } from "../../context/contextmanager";
import { getobj } from "../../apicall/apicall";
import { distributorUserContext } from "../../context/contexts";

export default function DistributorUserDrawer(props) {
  const [logo, setlogo] = useState();
  const distContext = useContext(distributorUserContext);

  const [buttonText, setbuttonText] = useState("Organizations");
  useEffect(() => {
    const customer_id = sessionStorage.getItem("customer_id");
    const url =
      process.env.REACT_APP_ZEWA_URL + "user/get-customer/" + customer_id + "/";
    const res = getobj(url);
    res.then(function (r) {
      setlogo(r.data.logo);
      props.setdistributor(r.data)
      //console.log(r,"drawer");
    });
  }, [props.refresh, props.setdistributor]);

  const history = useNavigate();

  const handleClick = (text) => {
    setbuttonText(text);
    if (text === "Logout") {
      handleLogout();
    } else {
      const nm = getKeyByValue(distContext.page, true);
      props.setsearch("");

      distContext.setpage({
        ...distContext.page,
        [nm]: false,
        [text]: true,
      });
    }
  };
  const handleLogout = () => {
    sessionStorage.setItem("token", "");
    history({ pathname: "/" });
    window.location.reload(true);
    localStorage.setItem("role", "")
  };

  return (
    <div className="drawer-admin">
      <Drawer sx={drawer} variant="permanent" anchor="left">
        <div>
          <img
            style={logoStyle2}
            src="https://zewa-logo-bucket.s3.amazonaws.com/rpm-logo.png"
            alt="logo"
          />

          <List>
            {["Organizations", "Settings", "Logout"].map((text, index) => (
              <ListItem
                key={text}
                disablePadding
                className={
                  text === buttonText ? "active drawer-item" : "drawer-item"
                }
              >
                <ListItemButton
                  onClick={() => {
                    handleClick(text);
                  }}
                >
                  <ListItemIcon>
                    {index === 0 && <PeopleIcon style={{ color: "white" }} />}
                    {index === 1 && <SettingsIcon style={{ color: "white" }} />}

                    {index === 2 && <LogoutIcon style={{ color: "white" }} />}
                  </ListItemIcon>
                  <ListItemText primary={text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          {/* <img style={zewalogo_customer} src={logo} alt="cust-logo"/> */}
        </div>
      </Drawer>
    </div>
  );
}
